import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import type {
  CandidatePublicView,
  RegisterCandidateRequest,
  RegisterCandidateResponse,
  CandidateProfile,
  UpdateCandidateProfileRequest,
} from '../types/candidate-app.types';

export const candidateAppService = {
  async getCandidateByShareId(shareId: string): Promise<CandidatePublicView> {
    const response = await apiClient<ApiResponse<CandidatePublicView>>(
      `/public/candidates/${shareId}`,
      { method: 'GET' }
    );
    return response.data;
  },

  async registerCandidate(
    shareId: string,
    request: RegisterCandidateRequest
  ): Promise<RegisterCandidateResponse> {
    const response = await apiClient<ApiResponse<RegisterCandidateResponse>>(
      `/public/candidates/${shareId}/register`,
      { method: 'POST', body: request }
    );
    return response.data;
  },

  async getCandidateProfile(): Promise<CandidateProfile> {
    const response = await apiClient<ApiResponse<CandidateProfile>>('/candidate/profile', {
      method: 'GET',
    });
    return response.data;
  },

  async updateProfile(request: UpdateCandidateProfileRequest): Promise<CandidateProfile> {
    const response = await apiClient<ApiResponse<CandidateProfile>>('/candidate/profile', {
      method: 'PUT',
      body: request,
    });
    return response.data;
  },

  async getProfileByShareId(shareId: string): Promise<CandidateProfile> {
    const response = await apiClient<ApiResponse<CandidateProfile>>(
      `/public/candidates/${shareId}/profile`,
      { method: 'GET' }
    );
    return response.data;
  },

  async updateProfileByShareId(
    shareId: string,
    request: UpdateCandidateProfileRequest
  ): Promise<CandidateProfile> {
    const response = await apiClient<ApiResponse<CandidateProfile>>(
      `/public/candidates/${shareId}/profile`,
      { method: 'PUT', body: request }
    );
    return response.data;
  },

  async giveConsent(shareId: string): Promise<void> {
    await apiClient(`/public/candidates/${shareId}/consent`, {
      method: 'PATCH',
      body: { over16: true, termsAccepted: true },
    });
  },
};
